/* Vloeren-PDP -- brok A: rekenhulp en benodigdheden.

   Alles wat deze module nodig heeft staat in de HTML: de vloergegevens
   als data-attributen op het formulier, de toebehorengegevens op de
   items, de teksten in een JSON-blok. Er zit geen productkennis in dit
   bestand -- geen percentages, geen prijzen, geen aannames over
   verpakkingen. Draait de JS niet, dan blijft de pagina leesbaar en post
   het formulier gewoon een pak naar de winkelwagen.

   Bedragen zijn overal centen (integers) tot het moment van tonen. */

(function () {
  'use strict';

  var wortel = document.querySelector('[data-solza-vloer]');
  if (!wortel) return;

  var formulier = wortel.querySelector('[data-solza-rekenhulp]');
  if (!formulier) return;

  var teksten = {};
  var tekstblok = wortel.querySelector('[data-solza-vloer-teksten]');
  if (tekstblok) {
    try {
      teksten = JSON.parse(tekstblok.textContent);
    } catch (e) {
      teksten = {};
    }
  }

  function tekst(sleutel, waarden) {
    var t = teksten[sleutel] || '';
    if (!waarden) return t;
    Object.keys(waarden).forEach(function (k) {
      t = t.split('%' + k + '%').join(waarden[k]);
    });
    return t;
  }

  var vloer = {
    pak: parseFloat(formulier.dataset.pak) || 0,
    prijsPak: parseInt(formulier.dataset.prijsPak, 10) || 0,
    snijverlies: parseInt(formulier.dataset.snijverlies, 10) || 0,
    minPakken: parseInt(formulier.dataset.minPakken, 10) || 0,
    minM2: parseFloat(formulier.dataset.minM2) || 0,
    voorraadStatus: formulier.dataset.voorraadStatus || 'geen',
    voorraadM2: parseInt(formulier.dataset.voorraadM2, 10) || 0
  };
  if (vloer.pak <= 0) return;

  var velden = {
    m2: formulier.querySelector('[data-solza-m2]'),
    lengte: formulier.querySelector('[data-solza-lengte]'),
    breedte: formulier.querySelector('[data-solza-breedte]'),
    lwh: formulier.querySelector('[data-solza-lwh]'),
    lwhSchakel: formulier.querySelector('[data-solza-lwh-schakel]'),
    aantal: formulier.querySelector('[data-solza-aantal]'),
    uitkomst: formulier.querySelector('[data-solza-uitkomst]'),
    nodig: formulier.querySelector('[data-solza-nodig]'),
    nodigLabel: formulier.querySelector('[data-solza-nodig-label]'),
    pakken: formulier.querySelector('[data-solza-pakken]'),
    vloertotaal: formulier.querySelector('[data-solza-vloertotaal]'),
    snijverliesRegel: formulier.querySelector('[data-solza-snijverlies-regel]'),
    snijverliesTekst: formulier.querySelector('[data-solza-snijverlies-tekst]'),
    snijverliesSchakel: formulier.querySelector('[data-solza-snijverlies-schakel]'),
    voorraadregel: formulier.querySelector('[data-solza-voorraadregel]'),
    totaal: formulier.querySelector('[data-solza-totaal]'),
    bestelknop: formulier.querySelector('[data-solza-bestelknop]'),
    fout: formulier.querySelector('[data-solza-fout]'),
    minimumregel: formulier.querySelector('[data-solza-minimumregel]'),
    m2Stappen: Array.prototype.slice.call(formulier.querySelectorAll('[data-solza-m2-stap]'))
  };

  var metSnijverlies = vloer.snijverlies > 0;

  /* ---------- opmaak ---------- */

  function geld(centen) {
    if (window.formatMoney && window.MinimogSettings && window.MinimogSettings.money_format) {
      return window.formatMoney(centen, window.MinimogSettings.money_format);
    }
    return '€ ' + (centen / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getal(n, decimalen) {
    return n.toLocaleString('nl-NL', { minimumFractionDigits: decimalen, maximumFractionDigits: decimalen });
  }

  /* Voor de regel die herhaalt wat de klant zelf invulde. Die hoort geen
     cijfer weg te laten en er ook geen bij te verzinnen: 28 blijft 28,
     23,4 blijft 23,4 en 12,14 blijft 12,14. Met een vaste decimaal zou het
     eerste "28,0" worden en het laatste "12,1", en dan staat er in de
     winkelmand iets anders dan de klant heeft ingetypt. */
  function getalKort(n) {
    return n.toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function lees(veld) {
    if (!veld) return 0;
    var n = parseFloat(String(veld.value).replace(',', '.'));
    return isNaN(n) || n < 0 ? 0 : n;
  }

  /* ---------- rekenen ---------- */

  function bereken() {
    var m2 = lees(velden.m2);
    var verlies = metSnijverlies ? vloer.snijverlies : 0;
    var nodig = m2 * (1 + verlies / 100);
    var pakken = m2 > 0 ? Math.ceil(nodig / vloer.pak) : 0;

    /* Eerder werd het aantal hier stilletjes opgehoogd naar het minimum.
       Dat leverde een bestelling op die de klant niet had ingevuld: je
       typt 3 m2 en er staat ineens 4 pakken in je mand. Nu blijft staan
       wat er is ingevuld en zegt de pagina wat eraan schort. */
    var onderMinimum = pakken > 0 && vloer.minPakken > 0 && pakken < vloer.minPakken;

    var besteld = pakken * vloer.pak;
    return {
      m2: m2,
      nodig: nodig,
      pakken: pakken,
      besteld: besteld,
      vloerCenten: pakken * vloer.prijsPak,
      leeg: m2 <= 0,
      onderMinimum: onderMinimum
    };
  }

  /* ---------- toebehoren ---------- */

  function items() {
    return Array.prototype.slice.call(wortel.querySelectorAll('[data-solza-item]'));
  }

  function itemAantal(item, besteld) {
    var eenheid = item.dataset.eenheid;
    var per = parseFloat(item.dataset.per) || 0;

    /* Een plint die via de lade is samengesteld heeft daar zijn aantal al
       gekregen, op basis van de muurlengte. Dat mag hier niet opnieuw
       berekend worden -- de m2 van de vloer zegt niets over de muurlengte. */
    if (item.dataset.vastAantal) return parseInt(item.dataset.vastAantal, 10) || 0;

    if (eenheid === 'm2') {
      if (per <= 0) return 1;
      if (besteld <= 0) return 0;
      return Math.ceil(besteld / per);
    }
    if (eenheid === 'm1') {
      var invoer = item.querySelector('[data-solza-m1]');
      if (!invoer || per <= 0) return 1;
      var m1 = lees(invoer);
      if (m1 <= 0) return 0;
      var verlies = parseInt(item.dataset.snijverlies, 10) || 0;
      return Math.ceil((m1 * (1 + verlies / 100)) / per);
    }
    /* Een droogloopmat komt van de rol en gaat per 10 cm lengte. Je vult
       de lengte in centimeters in; 87 cm wordt negen stappen. Geen
       snijverlies -- bij een mat is de snede de bestelling. De breedte is
       een variantoptie en geen invoer. */
    if (eenheid === 'cm10') {
      var cmInvoer = item.querySelector('[data-solza-cm]');
      if (!cmInvoer || per <= 0) return 1;
      var cm = lees(cmInvoer);
      if (cm <= 0) return 0;
      return Math.ceil(cm / per);
    }
    return 1;
  }

  function ververItems(uitkomst) {
    items().forEach(function (item) {
      var knop = item.querySelector('[data-solza-item-knop]');
      var prijsEl = item.querySelector('[data-solza-item-prijs]');
      var subEl = item.querySelector('[data-solza-item-sub]');
      var eenheid = item.dataset.eenheid;
      var per = parseFloat(item.dataset.per) || 0;
      var stuksPrijs = parseInt(item.dataset.prijs, 10) || 0;
      /* Een toegevoegde rij ligt vast: het aantal en de prijs blijven staan
         zoals ze de winkelwagen in zijn gegaan. Zou de rij meerekenen met
         een latere wijziging van de m2, dan stond er iets anders op het
         scherm dan er besteld is.

         De knop blijft uit. Dat moet hier gebeuren en niet alleen bij het
         toevoegen: de winkelwagenroutine geeft elke knop na afloop weer
         vrij, en daarna zou een tweede druk er stilletjes een tweede regel
         bij zetten. */
      if (isToegevoegd(item)) {
        /* Ook de plintrij, want die heeft geen toevoegknop maar een knop
           die de lade opent. Bleef die aan staan, dan kon je de lade
           opnieuw openen en er ongemerkt een tweede plint bij zetten. */
        var toegevoegdKnop = item.querySelector('[data-solza-item-knop], [data-solza-lade-open]');
        if (toegevoegdKnop) {
          toegevoegdKnop.disabled = true;
          toegevoegdKnop.textContent = tekst('toegevoegd');
        }
        return;
      }

      var aantal = itemAantal(item, uitkomst.besteld);
      var viaLade = !!item.dataset.vastAantal;

      item.dataset.aantal = aantal;
      item.dataset.regel = aantal * stuksPrijs;

      if (viaLade) return;

      if (prijsEl) {
        prijsEl.textContent = aantal > 0 ? geld(aantal * stuksPrijs) : geld(stuksPrijs);
      }

      if (subEl) {
        if (eenheid === 'm2' && per > 0 && aantal > 0) {
          subEl.textContent = tekst('item_rollen', { aantal: aantal, m2: getal(per, 1) });
        } else if (eenheid === 'm1' && per > 0) {
          subEl.textContent =
            aantal > 0
              ? tekst('item_stuks', {
                  aantal: aantal,
                  lengte: getal(per, 1),
                  procent: parseInt(item.dataset.snijverlies, 10) || 0
                })
              : tekst('item_plint_leeg', { prijs: geld(stuksPrijs) });
        } else if (eenheid === 'cm10' && per > 0) {
          subEl.textContent =
            aantal > 0
              ? tekst('item_mat', { aantal: aantal, cm: aantal * per })
              : tekst('item_mat_leeg', { prijs: geld(stuksPrijs) });
        }
      }

      /* Zonder aantal valt er niets toe te voegen: dan zou er een regel van
         nul stuks in de winkelwagen belanden. */
      if (knop) knop.disabled = aantal <= 0;
    });

    ververGroepen();
  }

  function ververGroepen() {
    Array.prototype.slice.call(wortel.querySelectorAll('[data-solza-groep]')).forEach(function (groep) {
      var status = groep.querySelector('[data-solza-groep-status]');
      if (!status) return;
      var aantal = 0;
      var bedrag = 0;
      Array.prototype.slice.call(groep.querySelectorAll('[data-solza-item]')).forEach(function (item) {
        if (!isToegevoegd(item)) return;
        aantal += 1;
        bedrag += parseInt(item.dataset.regel, 10) || 0;
      });
      if (aantal > 0) {
        status.textContent = tekst('groep_status', { aantal: aantal, bedrag: geld(bedrag) });
        status.hidden = false;
      } else {
        status.hidden = true;
      }
    });
  }

  /* Een regel is toegevoegd als hij daadwerkelijk in de winkelwagen zit.
     Elke rij gaat er met zijn eigen knop in; de bestelknop stuurt alleen de
     vloer. Eerder zette die knop enkel een vinkje en ging alles samen mee,
     en wie na het bestellen nog een plint aanvinkte kreeg de vloer een
     tweede keer in zijn winkelwagen.

     Wat toegevoegd is verandert daarna niet meer mee met de m2 van de
     vloer: het ligt in de winkelwagen zoals het besteld is, en daar is de
     winkelwagen de plek om het bij te stellen. */
  function isToegevoegd(item) {
    return item.dataset.toegevoegd === '1';
  }

  /* ---------- weergave ---------- */

  function verver() {
    var u = bereken();

    if (velden.uitkomst) velden.uitkomst.hidden = u.leeg;
    if (velden.nodig) velden.nodig.textContent = getal(u.nodig, 1) + ' m²';
    if (velden.nodigLabel) {
      velden.nodigLabel.textContent = metSnijverlies
        ? tekst('incl_snijverlies', { procent: vloer.snijverlies })
        : tekst('zonder_snijverlies');
    }
    if (velden.pakken) {
      var sleutel = u.pakken === 1 ? 'pakken_enkelvoud' : 'pakken_meervoud';
      velden.pakken.textContent = tekst(sleutel, { aantal: u.pakken, m2: getal(u.besteld, 2) });
    }
    if (velden.vloertotaal) velden.vloertotaal.textContent = geld(u.vloerCenten);
    if (velden.aantal) velden.aantal.value = u.pakken > 0 ? u.pakken : 1;

    if (velden.snijverliesRegel) {
      velden.snijverliesRegel.hidden = u.leeg;
      if (velden.snijverliesTekst) {
        velden.snijverliesTekst.textContent = metSnijverlies
          ? tekst('incl_snijverlies', { procent: vloer.snijverlies })
          : tekst('zonder_snijverlies');
      }
      if (velden.snijverliesSchakel) {
        velden.snijverliesSchakel.textContent = metSnijverlies
          ? tekst('schakel_zonder')
          : tekst('schakel_met', { procent: vloer.snijverlies });
      }
    }

    ververVoorraadregel(u);
    ververItems(u);

    /* Het totaal is dat van de vloer. De toebehoren staan eronder en gaan
       met hun eigen knop de winkelwagen in, dus optellen zou een bedrag
       beloven dat deze knop niet afrekent. */
    if (velden.totaal) velden.totaal.textContent = u.leeg ? '—' : geld(u.vloerCenten);

    /* Drie standen voor de bestelknop.

       Leeg: uitgeschakeld met "Vul je m2 in". Er valt nog niets te
       bestellen en er is niets misgegaan, dus ook geen melding.

       Onder het minimum: niet disabled maar aria-disabled. Een echt
       uitgeschakelde knop is niet aan te klikken en niet te focussen, en
       dan krijgt iemand met een schermlezer of toetsenbord nooit te horen
       waarom hij niet verder komt. Zo blijft de knop bereikbaar, legt de
       regel eronder het uit, en vangt de submit-afhandeling de klik op.

       Genoeg: gewone knop. */
    if (velden.bestelknop) {
      var wacht = !u.leeg && u.onderMinimum;
      velden.bestelknop.disabled = u.leeg;
      velden.bestelknop.classList.toggle('solza-vloer__knop--wacht', wacht);
      if (wacht) {
        velden.bestelknop.setAttribute('aria-disabled', 'true');
        velden.bestelknop.setAttribute('aria-describedby', 'solza-vloer-minimum');
      } else {
        velden.bestelknop.removeAttribute('aria-disabled');
        velden.bestelknop.removeAttribute('aria-describedby');
      }
      velden.bestelknop.textContent = u.leeg ? tekst('knop_leeg') : tekst('knop_bestel');
    }

    ververMinimumregel(u);
    ververStappen(u);
  }

  /* ---------- minimale afname ---------- */

  function ververMinimumregel(u) {
    var regel = velden.minimumregel;
    if (!regel) return;
    if (u.leeg || !u.onderMinimum) {
      regel.hidden = true;
      regel.classList.remove('solza-vloer__minimumregel--geraakt');
      return;
    }
    var sleutel = vloer.minPakken === 1 ? 'min_blokkade_enkel' : 'min_blokkade';
    regel.textContent = tekst(sleutel, {
      pakken: vloer.minPakken,
      m2: getal(vloer.minM2, 1)
    });
    regel.hidden = false;
  }

  /* De minknop stopt op het minimum. Hij is geen wisknop: naar nul ga je
     door het veld te selecteren en te typen. */
  function ververStappen(u) {
    if (!velden.m2Stappen.length) return;
    velden.m2Stappen.forEach(function (knop) {
      if (knop.dataset.solzaM2Stap !== '-1') return;
      /* Het veld toont een op twee decimalen afgeronde waarde, dus 11,16
         waar het minimum 11,156 is. Zonder die marge blijft de minknop
         aan staan op precies het minimum en lijkt hij stuk: klikken doet
         dan niets, want de klem eronder houdt de waarde vast. */
      knop.disabled = !u.leeg && u.m2 <= vloer.minM2 + 0.01;
    });
  }

  function ververVoorraadregel(u) {
    var regel = velden.voorraadregel;
    if (!regel) return;
    if (u.leeg || vloer.voorraadM2 <= 0 || (vloer.voorraadStatus !== 'leverbaar' && vloer.voorraadStatus !== 'krap')) {
      regel.hidden = true;
      return;
    }
    regel.hidden = false;
    var besteld = getal(u.besteld, 2);
    if (vloer.voorraadStatus === 'leverbaar') {
      /* "leverbaar" betekent: boven de ingestelde drempel. Meer weten we
         niet, dus staat er "meer dan" en nooit een exact aantal. */
      regel.classList.remove('solza-vloer__voorraadregel--krap');
      regel.textContent = tekst('voorraad_ruim', { m2: vloer.voorraadM2, nodig: besteld });
      return;
    }
    if (u.besteld <= vloer.voorraadM2) {
      regel.classList.remove('solza-vloer__voorraadregel--krap');
      regel.textContent = tekst('voorraad_krap_genoeg', { m2: vloer.voorraadM2, nodig: besteld });
    } else {
      regel.classList.add('solza-vloer__voorraadregel--krap');
      regel.textContent = tekst('voorraad_krap_kort', { m2: vloer.voorraadM2, nodig: besteld });
    }
  }

  /* ---------- bediening ---------- */

  if (velden.m2) {
    velden.m2.addEventListener('input', function () {
      if (velden.lengte) velden.lengte.value = '';
      if (velden.breedte) velden.breedte.value = '';
      verver();
    });
  }

  /* De stapknoppen schrijven in hetzelfde veld en roepen dezelfde verver()
     aan als typen. Geen tweede rekenpad: wat de knop doet, had de bezoeker
     ook kunnen typen, en dus kan de uitkomst niet uiteenlopen. */
  velden.m2Stappen.forEach(function (knop) {
    knop.addEventListener('click', function () {
      if (knop.disabled) return;
      var stap = parseFloat(knop.dataset.solzaM2Stap) || 0;
      var nu = lees(velden.m2);
      var nieuw;

      if (nu <= 0 && stap > 0) {
        /* Vanaf leeg meteen naar het minimum. Eén tik levert zo een
           bestelbare hoeveelheid op in plaats van 1 m2, waarna er nog een
           stuk of tien tikken nodig zouden zijn voordat de knop opengaat. */
        nieuw = vloer.minM2;
      } else {
        nieuw = nu + stap;
      }

      if (nieuw < vloer.minM2) nieuw = vloer.minM2;
      if (nieuw < 0) nieuw = 0;

      /* Afronden op twee decimalen: 23,4 + 1 geeft in drijvende komma
         24,400000000000002 en dat wil niemand in een invoerveld zien. */
      velden.m2.value = Math.round(nieuw * 100) / 100;
      if (velden.lengte) velden.lengte.value = '';
      if (velden.breedte) velden.breedte.value = '';
      verver();
    });
  });

  function uitLengteBreedte() {
    var opp = lees(velden.lengte) * lees(velden.breedte);
    if (velden.m2) velden.m2.value = opp > 0 ? Math.round(opp * 100) / 100 : '';
    verver();
  }
  if (velden.lengte) velden.lengte.addEventListener('input', uitLengteBreedte);
  if (velden.breedte) velden.breedte.addEventListener('input', uitLengteBreedte);

  if (velden.lwhSchakel && velden.lwh) {
    velden.lwhSchakel.setAttribute('aria-expanded', 'false');
    velden.lwhSchakel.addEventListener('click', function () {
      var open = velden.lwh.hidden;
      velden.lwh.hidden = !open;
      velden.lwhSchakel.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && velden.lengte) velden.lengte.focus();
    });
  }

  if (velden.snijverliesSchakel) {
    velden.snijverliesSchakel.addEventListener('click', function () {
      metSnijverlies = !metSnijverlies;
      verver();
    });
  }

  wortel.addEventListener('click', function (e) {
    var schakel = e.target.closest('[data-solza-groep-schakel]');
    if (schakel) {
      var groep = schakel.closest('[data-solza-groep]');
      var open = groep.hasAttribute('open');
      if (open) {
        groep.removeAttribute('open');
      } else {
        groep.setAttribute('open', '');
      }
      schakel.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }

    var itemKnop = e.target.closest('[data-solza-item-knop]');
    if (itemKnop) {
      var item = itemKnop.closest('[data-solza-item]');
      if (item && !isToegevoegd(item)) itemToevoegen(item, itemKnop);
      return;
    }

    var keuze = e.target.closest('[data-solza-vraag] button');
    if (keuze) {
      var groepje = keuze.closest('[data-solza-vraag]');
      Array.prototype.slice.call(groepje.querySelectorAll('button')).forEach(function (b) {
        b.setAttribute('aria-pressed', b === keuze ? 'true' : 'false');
      });
      ververAdvies();
    }
  });

  wortel.addEventListener('input', function (e) {
    if (e.target.matches('[data-solza-m1], [data-solza-cm]')) verver();
  });

  /* ---------- ondervloeradvies ----------

     Wat we hier doen is bewust beperkt tot wat de data ondersteunt. De
     warmteweerstand staat als getal op de ondervloerproducten, dus bij
     vloerverwarming kunnen we sorteren op de laagste. Een dB-waarde
     bestaat niet als veld; bij een VvE-eis staat er daarom een
     controleregel en wordt er niets gefilterd of beweerd. */

  function antwoord(naam) {
    var groepje = wortel.querySelector('[data-solza-vraag="' + naam + '"]');
    if (!groepje) return '';
    var aan = groepje.querySelector('button[aria-pressed="true"]');
    return aan ? aan.dataset.waarde : '';
  }

  /* De VvE-eis uit de vraag zelf: 10 dB contactgeluidreductie. Geen
     gekozen drempel, maar de waarde die in de vraag staat. */
  var DB_EIS = 10;

  function ververAdvies() {
    var groepEl = wortel.querySelector('[data-solza-groep="ondervloer"]');
    var uitkomst = wortel.querySelector('[data-solza-vraag-uitkomst]');
    var vw = antwoord('vloerverwarming');
    var db = antwoord('db');
    var magFilteren = !!(groepEl && groepEl.dataset.dbCompleet);

    if (uitkomst) {
      var regel = '';
      if (db === 'ja' && magFilteren) {
        regel = tekst('advies_db_gefilterd', { db: DB_EIS });
        if (vw === 'ja') regel = tekst('advies_vloerverwarming') + ' ' + regel;
      } else if (vw === 'ja' && db === 'ja') {
        regel = tekst('advies_beide');
      } else if (vw === 'ja') {
        regel = tekst('advies_vloerverwarming');
      } else if (db === 'ja') {
        regel = tekst('advies_db');
      }
      uitkomst.textContent = regel;
      uitkomst.hidden = regel === '';
    }

    var groep = groepEl && groepEl.querySelector('.solza-vloer__groep-body');
    if (!groep) return;
    var lijst = Array.prototype.slice.call(groep.querySelectorAll('[data-solza-item]'));

    /* Filteren mag alleen als élke ondervloer een dB-waarde heeft. Mist er
       een, dan zou het filter hem wegstrepen omdat de waarde onbekend is
       en niet omdat hij te zacht is. */
    lijst.forEach(function (item) {
      var verberg = false;
      if (db === 'ja' && magFilteren) {
        verberg = (parseFloat(item.dataset.db) || 0) < DB_EIS;
      }
      item.hidden = verberg;
    });

    if (vw !== 'ja') return;

    lijst
      .slice()
      .sort(function (a, b) {
        var ra = parseFloat(a.dataset.warmteweerstand);
        var rb = parseFloat(b.dataset.warmteweerstand);
        if (isNaN(ra)) return 1;
        if (isNaN(rb)) return -1;
        return ra - rb;
      })
      .forEach(function (item) {
        groep.appendChild(item);
      });
  }

  /* ---------- winkelwagen ---------- */

  function toonFout(bericht) {
    if (!velden.fout) return;
    velden.fout.textContent = bericht;
    velden.fout.hidden = false;
  }

  /* ---------- meten ----------

     De bestaande laag (snippets/oid-datalayer.liquid) vuurt op deze pagina
     al oid_view_item, en oid_add_to_cart bij een klik op de bestelknop --
     die selector (form[action="/cart/add"] [type="submit"]) raakt de
     rekenhulp ook. Dat event is alleen niet nauwkeurig: het gaat af bij de
     klik en niet bij het slagen, telt altijd één stuk, en kent het
     meebestelde toebehoren niet.

     Daarom hier een tweede, preciezer event met een eigen naam. Bewust
     geen tweede oid_add_to_cart: dan zou GA4 elke toevoeging dubbel
     tellen. Welke van de twee uiteindelijk de add_to_cart in GA4 voedt, is
     een knop in GTM en dus een keuze van Solza -- zie het bouwverslag. */

  function meldAanDataLayer(antwoord) {
    if (!window.dataLayer) return;
    var regels = (antwoord && antwoord.items) || [];
    if (!regels.length) return;

    var u = bereken();
    window.dataLayer.push({
      event: 'solza_vloer_add_to_cart',
      pageType: 'Product',
      vloer: {
        ingevoerde_m2: u.m2,
        besteld_m2: Math.round(u.besteld * 100) / 100,
        pakken: u.pakken,
        snijverlies_procent: metSnijverlies ? vloer.snijverlies : 0,
        vloertype: wortel.dataset.vloertype || '',
        legmethode: wortel.dataset.legmethode || ''
      },
      ecommerce: {
        currency: (window.MinimogSettings && window.MinimogSettings.currencyCode) || undefined,
        value: regels.reduce(function (som, r) {
          return som + (r.final_line_price || r.line_price || 0) / 100;
        }, 0),
        items: regels.map(function (r) {
          return {
            item_id: r.product_id,
            item_variant: r.variant_title,
            item_name: r.product_title || r.title,
            item_brand: r.vendor,
            price: (r.final_price || r.price || 0) / 100,
            quantity: r.quantity
          };
        })
      }
    });
  }

  /* Eén route naar de winkelwagen, voor zowel de bestelknop als de
     proefmonsterknop. De aanroep volgt precies wat het theme zelf doet
     bij een bundel: dezelfde fetchConfig, dezelfde secties meesturen,
     dezelfde events erna -- anders ververst de winkelwagenlade niet. */
  function naarWinkelwagen(regels, knop, tekstKlaar) {
    if (typeof window.fetchConfig !== 'function' || !window.MinimogSettings) return false;
    if (velden.fout) velden.fout.hidden = true;

    var lade = document.querySelector('m-cart-drawer');
    var body = { items: regels };
    if (lade && typeof lade.getSectionsToRender === 'function') {
      body.sections = lade.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    var config = window.fetchConfig('javascript');
    config.method = 'POST';
    config.body = JSON.stringify(body);

    var oudeTekst = knop ? knop.textContent : '';
    if (knop) {
      knop.disabled = true;
      knop.textContent = tekst('knop_bezig');
    }

    fetch(window.MinimogSettings.routes.cart_add_url, config)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) {
          toonFout(data.description || tekst('fout'));
          if (knop) knop.textContent = oudeTekst;
          return;
        }
        if (!window.MinimogSettings.use_ajax_atc) {
          window.location = window.MinimogSettings.routes.cart;
          return;
        }
        if (window.MinimogSettings.enable_cart_drawer && lade) {
          lade.renderContents(data);
        }
        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
        }
        meldAanDataLayer(data);
        if (knop) knop.textContent = tekstKlaar || oudeTekst;
      })
      .catch(function () {
        toonFout(tekst('fout'));
        if (knop) knop.textContent = oudeTekst;
      })
      .finally(function () {
        if (knop) knop.disabled = false;
        verver();
      });

    return true;
  }

  /* Eén regel voor de winkelwagen uit een rij toebehoren. */
  function itemRegel(item) {
    var regel = { id: item.dataset.vid, quantity: parseInt(item.dataset.aantal, 10) || 1 };
    /* Bij een mat is negen keer 10 cm één stuk van 90 cm en niet negen
       losse stukjes. Dat verschil moet mee naar het magazijn, anders
       wordt het verkeerd gesneden. */
    if (item.dataset.eenheid === 'cm10') {
      var lengte = regel.quantity * (parseFloat(item.dataset.per) || 10);
      regel.properties = {};
      regel.properties[tekst('eigenschap_breedte')] = tekst('eigenschap_breedte_waarde', { cm: lengte });
    }
    return regel;
  }

  /* Een rij toebehoren gaat met zijn eigen knop de winkelwagen in. Lukt
     dat, dan blijft de rij staan zoals hij besteld is en wordt de knop een
     stand en geen schakelaar meer: nog een keer drukken zou stilletjes een
     tweede regel opleveren. Lukt het niet, dan blijft alles zoals het was
     en staat de fout in het koopblok. */
  function itemToevoegen(item, knop) {
    if ((parseInt(item.dataset.aantal, 10) || 0) <= 0) return;

    var gelukt = naarWinkelwagen([itemRegel(item)], knop, tekst('toegevoegd'));
    if (!gelukt) return;

    item.dataset.toegevoegd = '1';
    item.classList.add('solza-vloer__item--gekozen');
    if (knop) {
      knop.setAttribute('aria-pressed', 'true');
      knop.disabled = true;
    }
  }

  formulier.addEventListener('submit', function (e) {
    var u = bereken();
    if (u.pakken <= 0) {
      e.preventDefault();
      return;
    }

    /* Onder het minimum gaat er niets naar de winkelwagen. De knop staat
       op aria-disabled en is dus wel aanklikbaar; die klik vangen we hier
       op en laten de regel eronder even oplichten, zodat duidelijk is dat
       er gereageerd is en waarop. Geen alert. */
    if (u.onderMinimum) {
      e.preventDefault();
      var regel = velden.minimumregel;
      if (regel && !regel.hidden) {
        regel.classList.remove('solza-vloer__minimumregel--geraakt');
        void regel.offsetWidth;
        regel.classList.add('solza-vloer__minimumregel--geraakt');
      }
      if (velden.m2) velden.m2.focus();
      return;
    }

    /* Zonder de theme-hulpmiddelen laten we het formulier gewoon posten;
       dan komt er een pak in de winkelwagen en gaat de bezoeker verder in
       de winkelwagen zelf. Beter dan een knop die niets doet. */
    var eigenschappen = {};
    eigenschappen[tekst('eigenschap_berekend')] = metSnijverlies
      ? tekst('eigenschap_waarde', { m2: getalKort(u.m2), procent: vloer.snijverlies })
      : tekst('eigenschap_waarde_kaal', { m2: getalKort(u.m2) });

    /* Dezelfde uitkomst nog een keer, maar dan om mee te rekenen. De regel
       hierboven is voor de klant en staat in de taal van de winkel: "30,8
       m2 incl. 10% snijverlies", met een komma. Liquid leest daar geen
       getal uit -- "30,8" wordt 30 -- en de winkelmand moet exact kunnen
       vergelijken om te zien of iemand onder zijn eigen berekening zakt.
       Een eigenschap met een liggend streepje ervoor is verborgen voor de
       klant en blijft wel in de order staan. */
    eigenschappen._solza_nodig = u.nodig.toFixed(2);

    /* Alleen de vloer. De toebehoren zijn al met hun eigen knop gegaan of
       gaan nog; ze hier meesturen zou ze een tweede keer toevoegen. */
    var regels = [{ id: formulier.querySelector('[name="id"]').value, quantity: u.pakken, properties: eigenschappen }];

    if (naarWinkelwagen(regels, velden.bestelknop, tekst('knop_bestel'))) e.preventDefault();
  });

  /* Proefmonster. De regel-eigenschappen zijn een kopie van wat de
     Product Samples-app wegschrijft, zodat een monster uit deze knop in
     de winkelwagen en in de order niet te onderscheiden is van een
     monster uit de app-knop. */
  var monsterknop = wortel.querySelector('[data-solza-monster]');
  if (monsterknop) {
    monsterknop.addEventListener('click', function () {
      var eig = {};
      eig[tekst('monster_van')] = monsterknop.dataset.titel;
      eig[tekst('monster_sku')] = monsterknop.dataset.sku;
      eig[tekst('monster_vendor')] = monsterknop.dataset.vendor;
      eig._sample_handle = monsterknop.dataset.handle;
      eig._sample_image = monsterknop.dataset.beeld;
      naarWinkelwagen([{ id: monsterknop.dataset.vid, quantity: 1, properties: eig }], monsterknop, tekst('monster_toegevoegd'));
    });
  }

  /* ---------- galerij ---------- */

  var hoofdbeeld = wortel.querySelector('#solza-vloer-hoofdbeeld');
  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Overvloeien in plaats van omklappen.

     De oude versie zette meteen src, width en height om. Dat gaf twee
     dingen tegelijk: het vak veranderde van hoogte doordat de verhouding
     van de nieuwe foto anders is, en er stond een leeg vak zolang die foto
     nog binnenkwam. Bij dit product springt de eerste foto van 10 op 13
     naar 3 op 2, ruim vierhonderd pixels.

     De hoogte is nu opgelost in de CSS: het vak is vierkant en de foto
     past er met contain in. Hier blijft het tweede deel over: eerst de
     nieuwe foto laten decoderen, dan pas omzetten, met een korte
     overvloeier eromheen. Geen width en height meer omzetten -- het vak
     ligt vast, dus die attributen zeggen niets meer over de layout. */
  var beeldTeller = 0;

  function toonBeeld(thumb) {
    if (!hoofdbeeld) return;
    var bron = thumb.dataset.groot;
    var beurt = ++beeldTeller;

    function omzetten() {
      /* Alleen als er ondertussen niet al doorgeklikt is naar een andere
         foto: anders zet een trage foto de snellere weer terug. */
      if (beurt !== beeldTeller) return;
      hoofdbeeld.removeAttribute('srcset');
      hoofdbeeld.removeAttribute('sizes');
      hoofdbeeld.src = bron;
      hoofdbeeld.alt = thumb.dataset.alt || '';
      hoofdbeeld.classList.remove('is-wissel');
    }

    if (rustig) {
      omzetten();
      return;
    }

    hoofdbeeld.classList.add('is-wissel');

    /* Twee voorwaarden: de foto moet binnen zijn, en het uitvloeien moet
       afgelopen zijn. Zonder die tweede zou een foto uit de cache direct
       omgezet worden, halverwege het uitvloeien, en dan zie je hem
       schokkerig terugkomen.

       Beide als losse vlag en niet als afteller. Met een afteller hangt
       alles op de aanname dat elke tak precies een keer afgaat, en dat is
       bij een plaatje niet te garanderen: decode kan in een tabblad dat
       niet getekend wordt blijven staan, en dan bleef de foto hangen. */
    var geladen = false;
    var uitgevloeid = false;

    function probeer() {
      if (geladen && uitgevloeid) omzetten();
    }

    var laden = new Image();
    laden.onload = function () { geladen = true; probeer(); };
    laden.onerror = function () { geladen = true; probeer(); };
    laden.src = bron;
    if (laden.complete) {
      geladen = true;
    }

    window.setTimeout(function () { uitgevloeid = true; probeer(); }, 200);
    /* Vangnet. Komt de foto niet binnen, dan is een trage wissel nog altijd
       beter dan een vak dat leeg blijft. */
    window.setTimeout(function () { geladen = true; probeer(); }, 1200);
  }

  wortel.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-solza-thumb]');
    if (!thumb || !hoofdbeeld) return;
    toonBeeld(thumb);
    var alle = Array.prototype.slice.call(wortel.querySelectorAll('[data-solza-thumb]'));
    alle.forEach(function (t) {
      t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
    });

    /* De actieve miniatuur in beeld schuiven. Bij vijftien foto's past de
       rij niet meer en zou je met de pijlen naar een miniatuur bladeren die
       buiten beeld staat. nearest en niet center: dan blijft de rij staan
       zolang de miniatuur al zichtbaar is, in plaats van bij elke klik te
       verspringen. */
    if (typeof thumb.scrollIntoView === 'function') {
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    var teller = wortel.querySelector('[data-solza-beeld-teller]');
    if (teller) teller.textContent = alle.indexOf(thumb) + 1 + ' / ' + alle.length;
  });

  /* ---------- bladeren door de foto's ----------

     De pijlen en het vegen doen hetzelfde: ze klikken een miniatuur aan.
     Zo staat het wisselen van de foto op één plek en kan het niet uit
     elkaar lopen. Rondlopen aan beide kanten, want vastlopen op de laatste
     foto voelt als een kapotte knop. */
  function beeldStap(richting) {
    var alle = Array.prototype.slice.call(wortel.querySelectorAll('[data-solza-thumb]'));
    if (alle.length < 2) return;
    var nu = alle.findIndex
      ? alle.findIndex(function (t) {
          return t.getAttribute('aria-pressed') === 'true';
        })
      : -1;
    if (nu < 0) nu = 0;
    var volgend = (nu + richting + alle.length) % alle.length;
    alle[volgend].click();
  }

  var beeldVorige = wortel.querySelector('[data-solza-beeld-vorige]');
  var beeldVolgende = wortel.querySelector('[data-solza-beeld-volgende]');
  if (beeldVorige) beeldVorige.addEventListener('click', function () { beeldStap(-1); });
  if (beeldVolgende) beeldVolgende.addEventListener('click', function () { beeldStap(1); });

  /* ---------- de miniaturenrij zelf schuiven ----------

     Los van de pijlen over de foto. Die bladeren naar de volgende foto en
     wisselen dus ook het hoofdbeeld; deze twee schuiven alleen de rij op,
     zodat je kunt kijken welke foto je wilt voordat je klikt.

     De rij heeft bewust geen zichtbare scrollbalk. Met een muis was er
     daardoor geen enkele manier om bij de laatste miniaturen te komen:
     slepen werkt op een touchscreen en het wiel scrollt verticaal. Deze
     twee knoppen zijn die manier.

     Ze staan verborgen als de rij past. Vier foto's hoeven geen pijlen. */
  var thumbspoor = wortel.querySelector('[data-solza-thumbspoor]');
  var thumbpijlen = Array.prototype.slice.call(wortel.querySelectorAll('[data-solza-thumbschuif]'));

  if (thumbspoor && thumbpijlen.length) {
    var pijlTerug = wortel.querySelector('[data-solza-thumbschuif="terug"]');
    var pijlVerder = wortel.querySelector('[data-solza-thumbschuif="verder"]');

    function pijlenBijwerken() {
      /* Een pixel speling: bij een gebroken breedte kan scrollWidth een
         fractie boven clientWidth liggen zonder dat er iets te schuiven
         valt, en dan zouden er twee dode knoppen staan. */
      var past = thumbspoor.scrollWidth <= thumbspoor.clientWidth + 1;
      var links = thumbspoor.scrollLeft;
      var rest = thumbspoor.scrollWidth - thumbspoor.clientWidth - links;
      if (pijlTerug) pijlTerug.hidden = past;
      if (pijlVerder) pijlVerder.hidden = past;
      /* Uitgegrijsd en niet verborgen aan het uiteinde: een knop die
         verspringt zodra je hem gebruikt, verschuift de rij eronder. */
      if (pijlTerug) pijlTerug.disabled = links <= 1;
      if (pijlVerder) pijlVerder.disabled = rest <= 1;
    }

    thumbpijlen.forEach(function (knop) {
      knop.addEventListener('click', function () {
        var eerste = thumbspoor.firstElementChild;
        if (!eerste) return;
        /* Drie miniaturen per klik: genoeg om op te schieten, weinig
           genoeg om te blijven zien waar je was. */
        var stap = (eerste.offsetWidth + 8) * 3;
        var richting = knop.getAttribute('data-solza-thumbschuif') === 'terug' ? -1 : 1;
        thumbspoor.scrollBy({ left: richting * stap, behavior: rustig ? 'auto' : 'smooth' });
        /* Ook na de klik nog een keer nakijken. Het scroll-event is de
           gewone route, maar bij een soepele schuif komt het laatste event
           na afloop en soms helemaal niet; dan bleef de knop aan het einde
           van de rij klikbaar. */
        window.setTimeout(pijlenBijwerken, 400);
      });
    });

    thumbspoor.addEventListener('scroll', pijlenBijwerken, { passive: true });
    window.addEventListener('resize', pijlenBijwerken);
    /* En nog een keer als alle miniaturen binnen zijn: tot dat moment is de
       rij smaller dan hij wordt, en dan zouden de pijlen verborgen blijven
       terwijl er wel te schuiven valt. */
    window.addEventListener('load', pijlenBijwerken);
    pijlenBijwerken();
  }

  /* Vegen op de hoofdfoto. Pointer events en geen touch events: die dekken
     ook de muis en de stylus, en er is er maar één set nodig.

     Vijftig pixels als drempel, en alleen als de horizontale beweging
     groter is dan de verticale -- anders zou een veeg om te scrollen ook
     de foto verspringen. */
  var hoofdvak = wortel.querySelector('.solza-vloer__hoofdbeeld');
  if (hoofdvak && typeof window.PointerEvent === 'function') {
    var startX = 0;
    var startY = 0;
    var bezig = false;

    hoofdvak.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      startX = e.clientX;
      startY = e.clientY;
      bezig = true;
    });

    hoofdvak.addEventListener('pointerup', function (e) {
      if (!bezig) return;
      bezig = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy)) return;
      beeldStap(dx < 0 ? 1 : -1);
    });

    hoofdvak.addEventListener('pointercancel', function () {
      bezig = false;
    });
  }

  /* ---------- kleuren ---------- */

  var meerKnop = wortel.querySelector('[data-solza-kleuren-meer]');
  if (meerKnop) {
    meerKnop.addEventListener('click', function () {
      Array.prototype.slice.call(wortel.querySelectorAll('.solza-vloer__kleur--verborgen')).forEach(function (k) {
        k.classList.remove('solza-vloer__kleur--verborgen');
      });
      meerKnop.remove();
    });
  }

  /* ---------- lades ----------

     Openen en sluiten is alleen het omzetten van hidden-attributen; de
     inhoud stond er al. Het paneel bepaalt zijn eigen kop via data-titel,
     zodat er geen tweede lijst met titels in dit bestand hoeft te staan. */

  var plintDoel = null;
  var lade = document.getElementById('solza-lade');
  var ladeTitel = document.getElementById('solza-lade-titel');
  var laatsteOpener = null;

  function ladeOpen(sleutel, opener) {
    if (!lade) return false;
    var paneel = lade.querySelector('[data-solza-lade-paneel="' + sleutel + '"]');
    if (!paneel) return false;

    Array.prototype.slice.call(lade.querySelectorAll('[data-solza-lade-paneel]')).forEach(function (p) {
      p.hidden = p !== paneel;
    });
    if (ladeTitel) ladeTitel.textContent = paneel.dataset.titel || '';

    lade.hidden = false;
    var waas = document.querySelector('.solza-lade-waas');
    if (waas) waas.hidden = false;
    document.body.style.overflow = 'hidden';

    laatsteOpener = opener || null;
    var eerste = lade.querySelector('.solza-lade__sluit');
    if (eerste) eerste.focus();
    return true;
  }

  function ladeDicht() {
    if (!lade || lade.hidden) return;
    lade.hidden = true;
    var waas = document.querySelector('.solza-lade-waas');
    if (waas) waas.hidden = true;
    document.body.style.overflow = '';
    if (laatsteOpener && document.contains(laatsteOpener)) laatsteOpener.focus();
    laatsteOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-solza-lade-open]');
    if (opener) {
      if (opener.hasAttribute('data-solza-plint-doel')) plintDoel = opener.closest('[data-solza-item]');
      if (ladeOpen(opener.dataset.solzaLadeOpen, opener)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-solza-lade-sluit]')) ladeDicht();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') ladeDicht();
  });

  /* ---------- plintkiezer ----------

     De varianten komen uit Shopify, server-side in een JSON-blok. Een
     combinatie die daar niet in staat, bestaat niet en is dus niet te
     kiezen: er wordt geen prijs geraden en geen combinatie verzonnen. */

  var plintPaneel = document.querySelector('[data-solza-plint]');

  if (plintPaneel) {
    var plintVarianten = [];
    try {
      plintVarianten = JSON.parse(plintPaneel.querySelector('[data-solza-plint-varianten]').textContent);
    } catch (e) {
      plintVarianten = [];
    }

    var plintPer = parseFloat(plintPaneel.dataset.per) || 0;
    var plintVerlies = parseInt(plintPaneel.dataset.snijverlies, 10) || 0;
    var plintGroepen = Array.prototype.slice.call(plintPaneel.querySelectorAll('[data-solza-plint-optie]'));
    var plintM1 = plintPaneel.querySelector('[data-solza-plint-m1]');
    var plintUit = plintPaneel.querySelector('[data-solza-plint-uitkomst]');
    var plintKies = plintPaneel.querySelector('[data-solza-plint-kies]');
    var plintKeuze = [];

    var plintZoek = function () {
      if (plintKeuze.filter(Boolean).length !== plintGroepen.length) return null;
      for (var i = 0; i < plintVarianten.length; i++) {
        var v = plintVarianten[i];
        var raak = true;
        for (var j = 0; j < plintKeuze.length; j++) {
          if (v.opties[j] !== plintKeuze[j]) {
            raak = false;
            break;
          }
        }
        if (raak) return v;
      }
      return null;
    };

    /* Een waarde is kiesbaar zolang er nog minstens een variant bestaat die
       met de eerder gemaakte keuzes en deze waarde overeenkomt. */
    var plintKiesbaar = function (index, waarde) {
      return plintVarianten.some(function (v) {
        if (v.opties[index] !== waarde) return false;
        for (var j = 0; j < index; j++) {
          if (plintKeuze[j] && v.opties[j] !== plintKeuze[j]) return false;
        }
        return true;
      });
    };

    var plintVerver = function () {
      plintGroepen.forEach(function (groep, index) {
        Array.prototype.slice.call(groep.querySelectorAll('button')).forEach(function (knop) {
          var kan = plintKiesbaar(index, knop.dataset.waarde);
          knop.disabled = !kan;
          if (!kan && plintKeuze[index] === knop.dataset.waarde) {
            plintKeuze[index] = null;
            knop.setAttribute('aria-pressed', 'false');
          }
        });
      });

      var v = plintZoek();
      var m1 = lees(plintM1);
      var stuks = m1 > 0 && plintPer > 0 ? Math.ceil((m1 * (1 + plintVerlies / 100)) / plintPer) : 0;

      if (plintKeuze.filter(Boolean).length !== plintGroepen.length) {
        plintUit.textContent = tekst('plint_start');
      } else if (!v) {
        plintUit.textContent = tekst('plint_niet_leverbaar');
      } else if (stuks <= 0) {
        plintUit.textContent = tekst('plint_per_stuk', { prijs: geld(v.prijs) }) + ' · ' + tekst('plint_geen_maat');
      } else {
        plintUit.textContent = tekst('plint_uitkomst', {
          aantal: stuks,
          lengte: getal(plintPer, 1),
          bedrag: geld(stuks * v.prijs),
          procent: plintVerlies
        });
      }

      plintKies.disabled = !(v && stuks > 0);
      return { variant: v, stuks: stuks };
    };

    plintPaneel.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-solza-plint-optie] button');
      if (!knop || knop.disabled) return;
      var groep = knop.closest('[data-solza-plint-optie]');
      var index = parseInt(groep.dataset.solzaPlintOptie, 10);
      Array.prototype.slice.call(groep.querySelectorAll('button')).forEach(function (b) {
        b.setAttribute('aria-pressed', b === knop ? 'true' : 'false');
      });
      plintKeuze[index] = knop.dataset.waarde;
      plintVerver();
    });

    if (plintM1) plintM1.addEventListener('input', plintVerver);

    plintKies.addEventListener('click', function () {
      var uit = plintVerver();
      if (!uit.variant || uit.stuks <= 0 || !plintDoel) return;

      /* De keuze gaat terug naar de regel in het benodigdhedenblok en gaat
         daarna meteen de winkelwagen in. Eerder bleef het bij een vinkje
         dat pas met de bestelknop meeging, en dat is precies waar het
         misging: wie de vloer al besteld had, kreeg hem er een tweede keer
         bij. Wat de klant hier bevestigt, ligt dus ook echt in zijn
         winkelwagen. */
      plintDoel.dataset.vid = uit.variant.id;
      plintDoel.dataset.prijs = uit.variant.prijs;
      plintDoel.dataset.eenheid = 'vast';
      plintDoel.dataset.per = 0;
      plintDoel.dataset.aantal = uit.stuks;
      plintDoel.dataset.regel = uit.stuks * uit.variant.prijs;
      plintDoel.dataset.vastAantal = uit.stuks;

      var sub = plintDoel.querySelector('[data-solza-item-sub]');
      if (sub) {
        sub.textContent =
          uit.variant.titel +
          ' · ' +
          tekst('item_stuks', { aantal: uit.stuks, lengte: getal(plintPer, 1), procent: plintVerlies });
      }
      var prijsEl = plintDoel.querySelector('[data-solza-item-prijs]');
      if (prijsEl) prijsEl.textContent = geld(uit.stuks * uit.variant.prijs);

      var knop = plintDoel.querySelector('[data-solza-lade-open="plint"]');
      ladeDicht();
      itemToevoegen(plintDoel, knop);
      verver();
    });

    plintVerver();
  }

  /* ---------- situaties (brok C) ----------

     Het antwoord staat al in de HTML; de knoppen zetten alleen hidden om.
     "Nee" verbergt het antwoord weer -- de klant heeft dan gezegd dat de
     situatie niet op hem slaat, en dan is het antwoord ruis. */

  var situaties = Array.prototype.slice.call(document.querySelectorAll('[data-solza-situatie]'));
  var conclusie = document.querySelector('[data-solza-conclusie]');
  var conclusieTekst = document.querySelector('[data-solza-conclusie-tekst]');

  /* De optelsom onder de vragen. Pas tonen als álle vragen beantwoord
     zijn: met de helft van de antwoorden zou er een oordeel staan dat op
     onvolledige informatie berust.

     Een "nee" op de vraag betekent dat de situatie niet op deze klant
     slaat, en telt dus als ok -- alleen een "ja" laat het oordeel van die
     vraag meewegen. Zwaarste uitkomst wint: één nee maakt het geheel nee. */
  function ververConclusie() {
    if (!conclusie || !conclusieTekst || !situaties.length) return;

    var alleBeantwoord = true;
    var zwaarste = 'ok';

    situaties.forEach(function (situatie) {
      var gekozen = situatie.querySelector('button[data-waarde][aria-pressed="true"]');
      if (!gekozen) { alleBeantwoord = false; return; }
      if (gekozen.dataset.waarde !== 'ja') return;
      var oordeel = situatie.dataset.oordeel || 'ok';
      if (oordeel === 'nee') zwaarste = 'nee';
      else if (oordeel === 'let' && zwaarste !== 'nee') zwaarste = 'let';
    });

    if (!alleBeantwoord) {
      conclusie.hidden = true;
      return;
    }

    conclusieTekst.textContent = conclusie.dataset[zwaarste] || '';
    conclusie.className = 'solza-vloer-passend__conclusie solza-vloer-passend__conclusie--' + zwaarste;
    conclusie.hidden = false;
  }

  situaties.forEach(function (situatie) {
    var antwoord = situatie.querySelector('[data-solza-situatie-antwoord]');
    situatie.addEventListener('click', function (e) {
      var knop = e.target.closest('button[data-waarde]');
      if (!knop) return;
      Array.prototype.slice.call(situatie.querySelectorAll('button[data-waarde]')).forEach(function (b) {
        b.setAttribute('aria-pressed', b === knop ? 'true' : 'false');
      });
      if (antwoord) antwoord.hidden = knop.dataset.waarde !== 'ja';
      ververConclusie();
    });
  });

  /* ---------- ankerbalk (brok C) ----------

     Een anker waarvan de band zich verbergt -- geen reviews, geen
     uitvoeringen -- hoort niet in de balk: er is niets om heen te
     springen. Dat kan alleen hier, want of een band rendert weet de
     server pas nadat de balk al gerenderd is. */

  var ankerbalk = document.querySelector('[data-solza-ankers]');
  if (ankerbalk) {
    var ankers = Array.prototype.slice.call(ankerbalk.querySelectorAll('[data-solza-anker]'));
    var doelen = [];

    ankers.forEach(function (anker) {
      var doel = document.getElementById(anker.dataset.solzaAnker);
      if (!doel) {
        anker.remove();
        return;
      }
      doelen.push({ anker: anker, doel: doel });
    });

    if (!doelen.length) {
      ankerbalk.remove();
    } else {
      /* Actieve band bepalen op basis van de positie in beeld. Bewust geen
         IntersectionObserver: op deze winkel scrollt de body en niet het
         document, waardoor een observer op de viewport-root helemaal geen
         callbacks krijgt (nagemeten: nul, ook de eerste niet).

         De berekening hangt aan een requestAnimationFrame, zodat er per
         beeldopbouw hooguit een keer gerekend wordt en de scroll zelf niets
         extra's op de main thread krijgt. */
      var wachtend = false;

      var bepaalActief = function () {
        wachtend = false;
        /* Net onder de scroll-margin-top van 64px: springt de klant naar
           een band, dan komt de bovenkant daarvan op 64px te liggen en moet
           die band de actieve zijn -- niet de band die er nog net boven
           doorloopt. */
        var grens = 140;
        var actief = null;
        doelen.forEach(function (paar) {
          var vak = paar.doel.getBoundingClientRect();
          if (vak.top <= grens && vak.bottom > grens) actief = paar;
        });
        if (!actief) {
          doelen.forEach(function (paar) {
            if (!actief && paar.doel.getBoundingClientRect().top > grens) actief = paar;
          });
        }
        doelen.forEach(function (paar) {
          paar.anker.classList.toggle('is-actief', paar === actief);
        });
      };

      /* Throttle met setTimeout en niet met requestAnimationFrame: rAF
         levert geen frames zolang het tabblad geen beeld opbouwt, en dan
         zou de balk na terugkeren op de verkeerde band blijven staan.
         Honderd milliseconde is ruim binnen wat een mens als direct
         ervaart, en houdt het rekenwerk tijdens scrollen beperkt. */
      var plan = function () {
        if (wachtend) return;
        wachtend = true;
        window.setTimeout(bepaalActief, 100);
      };

      document.addEventListener('scroll', plan, { passive: true, capture: true });
      window.addEventListener('resize', plan, { passive: true });
      bepaalActief();
    }
  }

  verver();

  /* ---------- Bid & Buy ----------

     De app rendert zijn eigen knop en modal in een appblok. Die knop staat
     onderaan de serviceband en dat leest raar: de uitnodiging hoort in de
     kaart zelf. De eigen knop van de app is daarom in CSS weggezet en onze
     knoppen geven de klik door.

     Twee bestemmingen, want twee vragen:

       keuze  het scherm "Kies je aanpak" -- bieden of een offerte voor de
              legservice. Dit is wat de eigen knop van de app doet.
       bod    rechtstreeks het biedformulier. Daarvoor klikken we na het
              keuzescherm ook de optie "Doe een bod" aan. Bestaat dat
              scherm niet -- de app laat het weg als er geen legservice bij
              deze vloer hoort -- dan staat het biedformulier er al en is
              er niets meer te doen.

     Doorgeven en niet zelf de modal openen: hoe de app zijn scherm opent is
     zijn zaak, en dat kan bij een update veranderen. Zijn eigen knop
     aanklikken blijft werken zolang die knop bestaat.

     De knoppen blijven links met een href. Is het appblok er niet -- op een
     ander sjabloon, of als de app-JS niet laadt -- dan gebeurt hier niets
     en doet de link gewoon wat een link doet. */
  var wachtOp = function (selector, klaar) {
    /* De app haalt zijn modal-script pas op bij de eerste klik, dus het
       keuzescherm staat er niet meteen. Twee seconden proberen en dan
       opgeven: langer wachten helpt niet meer en een klik die alsnog
       afgaat terwijl de bezoeker al iets anders doet is vervelender dan
       een keuzescherm dat blijft staan. */
    var tot = Date.now() + 2000;
    var kijk = function () {
      var el = document.querySelector(selector);
      if (el && !el.hasAttribute('hidden')) {
        klaar(el);
        return;
      }
      if (Date.now() < tot) window.setTimeout(kijk, 60);
    };
    kijk();
  };

  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-solza-bid-knop]');
    if (!knop) return;

    var launcher = document.querySelector('[data-solza-bid-block] [data-solza-open-modal]');
    if (!launcher) return;

    e.preventDefault();
    launcher.click();

    if (knop.getAttribute('data-solza-bid-knop') !== 'bod') return;
    wachtOp('[data-solza-chooser]', function (keuze) {
      var bod = keuze.querySelector('[data-solza-chooser-bid]');
      if (bod) bod.click();
    });
  });

  /* ---------- meer lezen bij de omschrijving en de specificaties ----------

     De inhoud staat er al; deze knop haalt alleen de hoogtegrens weg die de
     CSS op mobiel oplegt. Laadt dit bestand niet, dan staat de tekst
     afgesneden met een knop die niets doet -- vervelend, maar de tekst is
     via de broncode nog steeds compleet en zoekmachines zien hem gewoon.

     Dezelfde vorm als de knop in de collectie-intro: een gedelegeerde
     klik, aria-expanded op de knop, een klasse op het element waar hij
     naar wijst. Wie het daar begrijpt, begrijpt het hier ook. */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-solza-over-toggle]');
    if (!knop) return;

    var doel = document.getElementById(knop.getAttribute('aria-controls'));
    if (!doel) return;

    var open = knop.getAttribute('aria-expanded') === 'true';
    knop.setAttribute('aria-expanded', String(!open));
    doel.classList.toggle('is-open', !open);
    knop.textContent = open ? knop.dataset.labelMeer : knop.dataset.labelMinder;

    /* Bij het inklappen krimpt het blok boven de knop en schuift de knop
       mee omhoog, soms tot boven de bovenrand van het scherm. Dan staat de
       bezoeker ineens ergens anders op de pagina dan waar hij klikte. */
    if (open && knop.getBoundingClientRect().top < 0) {
      knop.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
})();